import { render, staticRenderFns } from "./AsSymptoms.vue?vue&type=template&id=10ff5fe0&scoped=true"
import script from "./AsSymptoms.vue?vue&type=script&lang=js"
export * from "./AsSymptoms.vue?vue&type=script&lang=js"
import style0 from "./AsSymptoms.vue?vue&type=style&index=0&id=10ff5fe0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10ff5fe0",
  null
  
)

export default component.exports